import vtkImageData from 'vtk.js/Sources/Common/DataModel/ImageData';
import vtkDataSetAttributes from 'vtk.js/Sources/Common/DataModel/DataSetAttributes';
import vtkDataArray from 'vtk.js/Sources/Common/Core/DataArray';
import { calculateDiameters } from 'rawmap-diameter-algo';

export function calculate(sliceData, sliceId) {
    const imageData = vtkImageData.newInstance();
    const pointData = vtkDataSetAttributes.newInstance();
    const dataArray = vtkDataArray.newInstance({
        empty: true,
        name: 'dicom_slice',
        dataType: 'Int16Array',
        numberOfComponents: 1,
    });
    dataArray.setData(sliceData.buffer);
    pointData.setScalars(dataArray);
    imageData.setPointData(pointData);
    imageData.setDimensions(sliceData.dimensions);
    imageData.setOrigin(sliceData.origin);
    imageData.setSpacing(sliceData.spacing);

    const diameters = calculateDiameters(imageData, sliceId);
    return {
        stentPlanningMin: isNaN(diameters.stentPlanningMin) ? 0 : diameters.stentPlanningMin,
        stentPlanningMax: isNaN(diameters.stentPlanningMax) ? 0 : diameters.stentPlanningMax,
        stentPlanningAverage: isNaN(diameters.stentPlanningAverage) ? 0 : diameters.stentPlanningAverage,
        AverageLine: typeof diameters.AverageLine === 'undefined' ? null : diameters.AverageLine,
        receivedType: diameters.receivedType,
        index: diameters.index,
        centerWorld: diameters.centerWorld,
        imageInfo: diameters.imageInfo,
        samples: typeof diameters.samples === 'undefined' ? null : diameters.samples,
    };
}